import script from "./stocks.vue?vue&type=script&setup=true&lang=js"
export * from "./stocks.vue?vue&type=script&setup=true&lang=js"

import "./stocks.vue?vue&type=style&index=0&id=9c0b7a80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c0b7a80"]])

export default __exports__